<script>
import store from '@state/store'
import { convertArrayToCSV } from 'convert-array-to-csv'
import { authComputed } from '@state/helpers'
import InitDateRange from '@reports/mixins/initDateRange.vue'
import DateRange from './dateRange.vue'

export default {
  components: {
    DateRange,
  },
  mixins: [InitDateRange],
  data() {
    return {
      total: {
        volunteerHours: [],
        actsOfKyndness: [],
        gratitude: [],
        donationDollars: [],
      },
      avg: {
        volunteerHours: [],
        actsOfKyndness: [],
        gratitude: [],
        donationDollars: [],
      },
      avgKyndhub: {
        volunteerHours: '',
        actsOfKyndness: '',
        gratitude: '',
        donationDollars: '',
      },
      count: {
        groupCount: '',
        userCount: '',
      },
      donationByCause: [],
      donationByOrganization: [],
      hoursByCause: [],
      hoursByOrganization: [],
      allData: [],
    }
  },
  computed: {
    ...authComputed,
    companyId() {
      return +this.$route.params.companyId
    },
  },
  mounted() {
    this.initLastTwoYearsData()
  },
  methods: {
    convertToCSV() {
      const TotalHeader = this.reportsLabel.map((item) => `Total${item}`)
      const AvgHeader = this.reportsLabel.map((item) => `AvgUser${item}`)
      const header = ['Time', ...TotalHeader, ...AvgHeader]

      const dataSettings = this.dataSettings
      const allData = this.allData
      const rows = allData.map((data, i) => [
        dataSettings[i].desc,
        data.totalVolunteerHours,
        data.totalActsOfKyndness,
        data.totalGratitude,
        data.totalDonationDollars,
        data.avgUserVolunteerHours,
        data.avgUserActsOfKyndness,
        data.avgUserGratitude,
        data.avgUserDonationDollars,
      ])

      rows.push([
        'Kyndhub',
        '',
        '',
        '',
        '',
        allData[0].avgUserVolunteerHoursKyndhub,
        allData[0].avgUserActsOfKyndnessKyndhub,
        allData[0].avgUserGratitudeKyndhub,
        allData[0].avgUserDonationDollarsKyndhub,
      ])

      return convertArrayToCSV(rows, { header })
    },
    exportDataPoints() {
      const csvString = this.convertToCSV()
      this.exportDataFunc(csvString, 'hubsReports.csv')
    },
    fetchData(dateRange) {
      const params = {
        companyId: this.companyId,
        from: dateRange.from,
        to: dateRange.to,
      }

      store
        .dispatch('reports/fetchHubsReport', params)
        .then((result) => {
          this.dataSettings.push(dateRange)
          this.allData.push(result)
          if (this.avgKyndhub.volunteerHours === '') {
            this.avgKyndhub.volunteerHours = result.avgUserVolunteerHoursKyndhub
            this.avgKyndhub.actsOfKyndness = result.avgUserActsOfKyndnessKyndhub
            this.avgKyndhub.gratitude = result.avgUserGratitudeKyndhub
            this.avgKyndhub.donationDollars =
              result.avgUserDonationDollarsKyndhub
          }
          if (this.count.userCount === '') {
            this.count.userCount = result.userCount
            this.count.groupCount = result.groupCount
          }
          if (!this.donationByCause.length) {
            const {
              donationByCause,
              donationByOrganization,
              hoursByCause,
              hoursByOrganization,
            } = result
            this.donationByCause = donationByCause
            this.donationByOrganization = donationByOrganization
            this.hoursByCause = hoursByCause
            this.hoursByOrganization = hoursByOrganization
          }

          this.total.volunteerHours.push(result.totalVolunteerHours)
          this.total.actsOfKyndness.push(result.totalActsOfKyndness)
          this.total.gratitude.push(result.totalGratitude)
          this.total.donationDollars.push(result.totalDonationDollars)

          this.avg.volunteerHours.push(result.avgUserVolunteerHours)
          this.avg.actsOfKyndness.push(result.avgUserActsOfKyndness)
          this.avg.gratitude.push(result.avgUserGratitude)
          this.avg.donationDollars.push(result.avgUserDonationDollars)
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    },
  },
}
</script>

<template>
  <div>
    <!-- date range -->
    <div class="flex justify-between border-b border-gray pb-8 mb-8">
      <DateRange
        @add-data-points="addDataPoints"
        @export-data-points="exportDataPoints"
      />
      <ul>
        <li
          v-for="report in dataSettings"
          :key="report.colorClass"
          class="flex items-center mb-1"
        >
          <span
            :class="report.colorClass"
            class="inline-block w-6 h-6 mr-3"
          ></span>
          <span class="font-bold text-basel">{{ report.desc }}</span>
        </li>
        <li class="flex items-center mb-1">
          <span class="bg-yellow-300 inline-block w-6 h-6 mr-3"></span>
          <span class="font-bold text-basel">Kyndhub</span>
        </li>
      </ul>
    </div>

    <!-- All Total -->
    <div class="border-b border-gray px-4 pb-8 mb-8">
      <div class="text-2xl text-gray mb-4">All Total</div>
      <!-- title -->
      <ul class="flex font-bold text-basel mb-3">
        <li
          v-for="reportlabel in reportsLabel"
          :key="reportlabel"
          class="w-1/4"
        >
          {{ reportlabel }}
        </li>
      </ul>
      <!-- data points -->
      <ul class="flex mb-2">
        <li class="w-1/4">
          <div
            v-for="(hour, i) in total.volunteerHours"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ hour }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(hour, total.volunteerHours)}px`,
              }"
            />
          </div>
        </li>
        <li class="w-1/4">
          <div
            v-for="(acts, i) in total.actsOfKyndness"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ acts }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(acts, total.actsOfKyndness)}px`,
              }"
            />
          </div>
        </li>
        <li class="w-1/4">
          <div
            v-for="(gratitude, i) in total.gratitude"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ gratitude }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(gratitude, total.gratitude)}px`,
              }"
            />
          </div>
        </li>
        <li class="w-1/4">
          <div
            v-for="(donation, i) in total.donationDollars"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ donation }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(donation, total.donationDollars)}px`,
              }"
            />
          </div>
        </li>
      </ul>

      <div class="font-bold text-lg mt-6">
        <span class="text-gray">Total User Count: </span>
        <span class="text-blue-darker">{{ count.userCount }}</span>
        <span class="text-gray ml-20">Total Group Count: </span>
        <span class="text-blue-darker">{{ count.groupCount }}</span>
      </div>
    </div>

    <!-- Per User Averages -->
    <div class="border-b border-gray px-4 pb-8">
      <div class="text-2xl text-gray mb-4">Per User Averages</div>
      <!-- title -->
      <ul class="flex font-bold text-basel mb-3">
        <li
          v-for="reportlabel in reportsLabel"
          :key="reportlabel"
          class="w-1/4"
        >
          {{ reportlabel }}/User
        </li>
      </ul>
      <!-- data points -->
      <ul class="flex mb-2">
        <li class="w-1/4">
          <div
            v-for="(volunteerHour, i) in avg.volunteerHours"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ volunteerHour }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(volunteerHour, [
                  ...avg.volunteerHours,
                  avgKyndhub.volunteerHours,
                ])}px`,
              }"
            />
          </div>
          <div class="flex items-center mb-2">
            <span class="mr-4 w-1/5">{{ avgKyndhub.volunteerHours }}</span>
            <div
              class="h-8 bg-yellow-300"
              :style="{
                width: `${getProgressbar(avgKyndhub.volunteerHours, [
                  ...avg.volunteerHours,
                  avgKyndhub.volunteerHours,
                ])}px`,
              }"
            />
          </div>
        </li>
        <li class="w-1/4">
          <div
            v-for="(actsOfKyndness, i) in avg.actsOfKyndness"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ actsOfKyndness }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(actsOfKyndness, [
                  ...avg.actsOfKyndness,
                  avgKyndhub.actsOfKyndness,
                ])}px`,
              }"
            />
          </div>
          <div class="flex items-center mb-2">
            <span class="mr-4 w-1/5">{{ avgKyndhub.actsOfKyndness }}</span>
            <div
              class="h-8 bg-yellow-300"
              :style="{
                width: `${getProgressbar(avgKyndhub.actsOfKyndness, [
                  ...avg.actsOfKyndness,
                  avgKyndhub.actsOfKyndness,
                ])}px`,
              }"
            />
          </div>
        </li>
        <li class="w-1/4">
          <div
            v-for="(gratitude, i) in avg.gratitude"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ gratitude }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(gratitude, [
                  ...avg.gratitude,
                  avgKyndhub.gratitude,
                ])}px`,
              }"
            />
          </div>
          <div class="flex items-center mb-2">
            <span class="mr-4 w-1/5">{{ avgKyndhub.gratitude }}</span>
            <div
              class="h-8 bg-yellow-300"
              :style="{
                width: `${getProgressbar(avgKyndhub.gratitude, [
                  ...avg.gratitude,
                  avgKyndhub.gratitude,
                ])}px`,
              }"
            />
          </div>
        </li>
        <li class="w-1/4">
          <div
            v-for="(donationDollars, i) in avg.donationDollars"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/5">{{ donationDollars }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${getProgressbar(donationDollars, [
                  ...avg.donationDollars,
                  avgKyndhub.donationDollars,
                ])}px`,
              }"
            />
          </div>
          <div class="flex items-center mb-2">
            <span class="mr-4 w-1/5">{{ avgKyndhub.donationDollars }}</span>
            <div
              class="h-8 bg-yellow-300"
              :style="{
                width: `${getProgressbar(avgKyndhub.donationDollars, [
                  ...avg.donationDollars,
                  avgKyndhub.donationDollars,
                ])}px`,
              }"
            />
          </div>
        </li>
      </ul>

      <div class="font-bold text-lg mt-6">
        <span class="text-blue-darker">Total User Count: </span>
        <span class="text-blue-darker">{{ count.userCount }}</span>
        <span class="text-blue-darker ml-20">Total Group Count: </span>
        <span class="text-blue-darker">{{ count.groupCount }}</span>
      </div>
    </div>

    <!-- sorted list by cause -->
    <div class="border-b border-gray pl-22 pb-6 pt-10">
      <div class="w-4/5 flex justify-between mx-auto">
        <div class="w-1/2">
          <div class="font-bold text-basel mb-3">
            Volunteer Hours by Cause
          </div>
          <ol class="pl-4">
            <li
              v-for="(hoursItem, i) in hoursByCause"
              :key="i"
              class="list-decimal pl-2 mb-2"
            >
              <span class="text-blue-darker">
                [{{ hoursItem.name }}] {{ hoursItem.sum }}
              </span>
            </li>
          </ol>
        </div>
        <div class="w-1/2">
          <div class="font-bold text-basel mb-3">
            Donation by Cause
          </div>
          <ol class="pl-4">
            <li
              v-for="(hoursItem, i) in donationByCause"
              :key="i"
              class="list-decimal pl-2 mb-2"
            >
              <span class="text-blue-darker">
                [{{ hoursItem.name }}] {{ hoursItem.sum }}
              </span>
            </li>
          </ol>
        </div>
      </div>
    </div>

    <!-- sorted list by organization -->
    <div class="pl-22 pb-4 pt-10">
      <div class="w-4/5 flex justify-between mx-auto">
        <div class="w-1/2">
          <div class="font-bold text-basel mb-3">
            Volunteer Hours by Organization
          </div>
          <ol class="pl-4">
            <li
              v-for="(hoursItem, i) in hoursByOrganization"
              :key="i"
              class="list-decimal pl-2 mb-2"
            >
              <span class="text-blue-darker">
                [{{ hoursItem.name }}] {{ hoursItem.sum }}
              </span>
            </li>
          </ol>
        </div>
        <div class="w-1/2">
          <div class="font-bold text-basel mb-3">
            Donation by Organization
          </div>
          <ol class="pl-4">
            <li
              v-for="(hoursItem, i) in donationByOrganization"
              :key="i"
              class="list-decimal pl-2 mb-2"
            >
              <span class="text-blue-darker">
                [{{ hoursItem.name }}] {{ hoursItem.sum }}
              </span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>
